import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import InputLabel from "@material-ui/core/InputLabel";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";
import Slide from "@material-ui/core/Slide";
import { observer } from "mobx-react";
import _ from "lodash";

// Local Modules
import PlayerDropdownSearch from "../PlayerDropdownSearch";

const transition = (props) => <Slide direction="up" {...props} />;
const commonBoolean = ["True", true, 1];

const PlayerDialog = observer(
  ({ player, isOpen, handleClose, updateField, title, idAgent }) => {
    const reverseCountsDouble = _.includes(
      commonBoolean,
      player.ReverseCountsDouble
    );
    const ezLive = _.includes(commonBoolean, player.EZlive);
    const cwsLive = _.includes(commonBoolean, player.CWSlive);
    const isEdit =
      _.includes(title, "Edit player") || _.includes(title, "Edit agent");

    return (
      <Dialog
        {...{
          open: isOpen,
          TransitionComponent: transition,
          keepMounted: true,
          onClose: handleClose,
          "aria-labelledby": "alert-dialog-slide-title",
          "aria-describedby": "alert-dialog-slide-description",
        }}
      >
        <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
        <DialogContent>
          <Grid container spacing={0}>
            <Grid item xs={6} style={{ padding: 10 }}>
              {isEdit && (
                <TextField
                  {...{
                    margin: "dense",
                    value: _.includes(title, "Edit agent")
                      ? player.Agent
                      : player.Player,
                    id: "name",
                    label: _.includes(title, "Edit agent")
                      ? "Agent name"
                      : "Player name",
                    fullWidth: true,
                    disabled: true,
                  }}
                />
              )}
              {!isEdit && (
                <PlayerDropdownSearch
                  {...{
                    prmIdAgent: idAgent,
                    agentFilter: true,
                    displayAllPlayers: false,
                    defaultInputVal: !_.includes(
                      [null, "DEFAULT"],
                      player.Player
                    )
                      ? player.Player
                      : "",
                    classesProps: {
                      input: {},
                      container: {
                        marginTop: 5,
                        position: "relative",
                        zIndex: 20,
                      },
                    },
                    onChangeOutside: (value) => {
                      updateField(player, "Player", value, isEdit);
                    },
                    onSelectPlayer: (selectedPlayer) => {
                      const params = _.split(selectedPlayer, "|");
                      updateField(player, "Player", params[1], isEdit);
                    },
                  }}
                />
              )}
            </Grid>

            <Grid item xs={6} style={{ padding: 10 }}>
              <TextField
                {...{
                  value: player.GlobalMaxPay ? player.GlobalMaxPay : "",
                  margin: "dense",
                  id: "name",
                  label: "Global max pay",
                  fullWidth: true,
                  onChange: (e) => {
                    updateField(player, "GlobalMaxPay", e.target.value, isEdit);
                  },
                }}
              />
            </Grid>

            <Grid item xs={6} style={{ padding: 10 }}>
              <TextField
                {...{
                  value: player.ReverseLimit ? player.ReverseLimit : "",
                  autoFocus: true,
                  margin: "dense",
                  id: "name",
                  label: "Reverse Limit",
                  fullWidth: true,
                  onChange: (e) => {
                    updateField(player, "ReverseLimit", e.target.value, isEdit);
                  },
                }}
              />
            </Grid>

            <Grid item xs={6} style={{ padding: 10 }}>
              <TextField
                {...{
                  value: player.LiveCasinoWeeklyLimit
                    ? player.LiveCasinoWeeklyLimit
                    : "",
                  margin: "dense",
                  id: "name",
                  label: "Live casino weekly limit",
                  fullWidth: true,
                  onChange: (e) => {
                    updateField(
                      player,
                      "LiveCasinoWeeklyLimit",
                      e.target.value,
                      isEdit
                    );
                  },
                }}
              />
            </Grid>

            <Grid item xs={6} style={{ padding: 10 }}>
              <InputLabel htmlFor="age-simple">UI Version: </InputLabel>
              <Select
                value={player.UI_Version}
                onChange={(e) => {
                  updateField(player, "UI_Version", e.target.value, isEdit);
                }}
                inputProps={{
                  name: "ui_version",
                  id: "ui_versionsimpl",
                }}
              >
                <MenuItem value={"1"}>1</MenuItem>
                <MenuItem value={"2"}>2</MenuItem>
              </Select>
            </Grid>

            <Grid item xs={5} style={{ padding: 10 }}>
              <FormControlLabel
                control={
                  <Switch
                    {...{
                      checked: reverseCountsDouble,
                      color: "primary",
                      onChange: (e) => {
                        updateField(
                          player,
                          "ReverseCountsDouble",
                          e.target.checked,
                          isEdit
                        );
                      },
                    }}
                  />
                }
                label="Reverse counts double"
              />
            </Grid>

            <Grid item xs={4} style={{ padding: 10 }}>
              <FormControlLabel
                control={
                  <Switch
                    {...{
                      checked: cwsLive,
                      color: "primary",
                      onChange: (e) => {
                        updateField(
                          player,
                          "CWSlive",
                          e.target.checked,
                          isEdit
                        );
                      },
                    }}
                  />
                }
                label="CWS live"
              />
            </Grid>

            <Grid item xs={3} style={{ padding: 10 }}>
              <FormControlLabel
                control={
                  <Switch
                    {...{
                      checked: ezLive,
                      color: "primary",
                      onChange: (e) => {
                        updateField(player, "EZlive", e.target.checked, isEdit);
                      },
                    }}
                  />
                }
                label="EZ live"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose({})} color="primary">
            Cancel
          </Button>
          <Button
            {...{
              onClick: () => handleClose(player),
              color: "primary",
              // disabled: !canSave
            }}
          >
            {isEdit ? "Save Player" : "Save Agent"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

PlayerDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default PlayerDialog;
